import React from 'react'

const DownloadIcon = ({color = '#808F94', ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={22}
      viewBox="0 0 25 22"
      fill="none"
      {...props}
    >
      <path
        fill={color}
        d="M0 11.445c0-2.304 1.377-4.111 3.584-4.453.049-2.744 2.852-4.463 5.068-3.867C9.824 1.416 11.71 0 14.356 0c3.994 0 7.128 3.145 7.109 7.5 1.904.771 3.086 2.393 3.086 4.365 0 2.364-1.797 4.17-4.795 4.17h-6.66V9.844a.77.77 0 0 0-.772-.752c-.42 0-.781.342-.781.752v6.191h1.553v2.197l-.069 1.475.557-.596 1.504-1.611a.724.724 0 0 1 .537-.225c.4 0 .713.284.713.684 0 .205-.088.361-.235.508l-3.222 3.105c-.196.196-.361.264-.557.264-.205 0-.37-.068-.566-.264l-3.223-3.105c-.146-.147-.234-.303-.234-.508 0-.4.293-.684.703-.684.195 0 .4.069.537.225l1.514 1.611.556.596-.068-1.475v-2.197H5.107c-3.203 0-5.107-2.05-5.107-4.59Z"
      />
    </svg>
  )
}

export default DownloadIcon
